module.exports = __webpack_public_path__ + "static/media/pot-576173_1280.04403a42.png";